export default "__VITE_ASSET__Bks3kUua__"